import { SingleDataValue } from '../data-display';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const ResourceTileDevGuides = ({ animate }) => {

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue
        label="Contribute"
        value="Bitcoin Dev Guides"
        link="https://github.com/jonatack/bitcoin-development/blob/master/README.md"
      />
    </ThemedFlex>
  );
};
